import tools from './tools';

// DatetimeInput component
export default function (options = {}, config = {}) {
    let root, instance;
    let instantiated = false;

    return {
        opened: false,

        get value() {
            return root._x_model ? root._x_model.get() : root.value;
        },

        set value(value) {
            if (options.mode === 'single') {
                if (value) {
                    if (!(value instanceof Date)) {
                        value = window.flatpickr.parseDate(value, options.format.replace(/a/i, 'K')) ?? value;
                    }

                    return Helper.formatDate(value, options.format);
                } else {
                    return '';
                }
            }

            root._x_model ? root._x_model.set(value) : (root.value = value);
        },

        instance() {
            return instance;
        },

        init() {
            root = this.$root;

            if (this.isInModal) {
                this.instantiate();
            }
        },

        destroy() {
            try {
                instance.destroy();
            } catch (error) {}
        },

        instantiate() {
            if (instantiated) return;
            instantiated = true;

            const locale = window.App.locale === 'en' ? window.flatpickr.l10ns.en : Object.values(window[window.App.locale])[0];

            root.classList.add('bg-white');

            const setInstanceDate = (instance, dateStr) => instance.setDate(dateStr, false, options.format.replace(/a/i, 'K'));

            instance = window.flatpickr(
                root,
                Object.assign(
                    {
                        locale: Object.assign(locale, { rangeSeparator: options.rangeSeparator }),
                        mode: options.mode,
                        allowInput: true,
                        showMonths: options.showMonths,
                        dateFormat: options.format,
                        noCalendar: !/y|m|n|d|j/i.test(options.format),
                        enableTime: /g|h|i|s/i.test(options.format),
                        enableSeconds: options.format.includes('s'),
                        time_24hr: /G|H/.test(options.format),
                        minDate: options.minDate,
                        maxDate: options.maxDate,
                        formatDate: (value, format) => Helper.formatDate(value, format),
                        onOpen: (selectedDates, dateStr, instance) => {
                            this.opened = true;
                            setInstanceDate(instance, dateStr);
                        },
                        onClose: (selectedDates, dateStr, instance) => {
                            this.opened = false;
                            this.value = options.mode === 'single' ? (selectedDates[0] ?? '') : dateStr;
                            setInstanceDate(instance, dateStr);
                        },
                        errorHandler: (error) => {
                            if (!error.message.includes('Invalid date provided')) {
                                console.error(error);
                            }
                        },
                    },
                    config
                )
            );

            if (instance.config.enableTime && !options.format.includes('i')) {
                instance.minuteElement.parentElement.previousElementSibling.style.display = 'none';
                instance.minuteElement.parentElement.style.display = 'none';
            }

            if (options.format.includes('a')) {
                instance.amPM.style.textTransform = 'lowercase';
            }

            if (this.isInModal) {
                const type = 'focusin';
                const listener = (event) => event.stopImmediatePropagation();

                if (IS_BOOTSTRAP4) {
                    $(instance.calendarContainer).on(type, listener);
                } else if (IS_BOOTSTRAP5) {
                    instance.calendarContainer.addEventListener(type, listener);
                }
            }

            this.$nextTick(() => {
                if (root._x_model) {
                    this.$watch(tools.getXModelValue(root), (value) => setInstanceDate(instance, value ?? ''));

                    setInstanceDate(instance, root._x_model.get() ?? '');
                }
            });
        },
    };
}
